// 来店トースト。「ルナモスが来た！ +6💰」のような短い通知を画面上部に出す。
//
// DOM 直組みの軽量実装（React なし方針）。表示は数秒で自動的に消える。
// 同時に複数来ても縦に積めるよう、コンテナに append していく。

const SHOW_MS = 2600;
/** 同時に積むトーストの上限。超えたら古いものから即除去（加速時のスタック埋め尽くし防止）。 */
const MAX_TOASTS = 4;

export interface ToastHost {
  /** 1 件トーストを出す。 */
  show(message: string): void;
}

export function createToastHost(container: HTMLElement): ToastHost {
  function show(message: string): void {
    // 上限を超えていたら最古のトーストを先に片付ける（加速モードで札が溜まり続けないように）。
    while (container.childElementCount >= MAX_TOASTS) {
      container.firstElementChild?.remove();
    }
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    container.appendChild(el);
    // 次フレームで show クラスを付けてトランジションを発火
    requestAnimationFrame(() => el.classList.add('show'));

    window.setTimeout(() => {
      el.classList.remove('show');
      // フェードアウト後に DOM から除去
      window.setTimeout(() => el.remove(), 300);
    }, SHOW_MS);
  }

  return { show };
}

/** 来店 1 件のトースト文言を組む（「○○が来た！ +N💰」）。 */
export function visitToastMessage(customerName: string, icon: string, tip: number): string {
  return `${icon} ${customerName}が来た！ +${tip}💰`;
}
